var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0897 19.7773H2.90904C2.40701 19.7773 2 20.2748 2 20.8884C2 21.5021 2.40701 21.9996 2.90904 21.9996H21.0897C21.5917 21.9996 21.9987 21.5021 21.9987 20.8884C21.9987 20.2748 21.5918 19.7773 21.0897 19.7773Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0892 15.333H11.9989C11.4968 15.333 11.0898 15.8305 11.0898 16.4441C11.0898 17.0577 11.4968 17.5552 11.9989 17.5552H21.0892C21.5912 17.5552 21.9982 17.0577 21.9982 16.4441C21.9982 15.8305 21.5913 15.333 21.0892 15.333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0892 10.8887H11.9989C11.4968 10.8887 11.0898 11.3861 11.0898 11.9998C11.0898 12.6134 11.4968 13.1109 11.9989 13.1109H21.0892C21.5912 13.1109 21.9982 12.6134 21.9982 11.9998C21.9982 11.3861 21.5913 10.8887 21.0892 10.8887Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90904 4.22221H21.0897C21.5917 4.22221 21.9987 3.72473 21.9987 3.1111C21.9987 2.49748 21.5917 2 21.0897 2H2.90904C2.40701 2 2 2.49748 2 3.1111C2 3.72473 2.40701 4.22221 2.90904 4.22221Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0892 6.44434H11.9989C11.4968 6.44434 11.0898 6.94181 11.0898 7.55544C11.0898 8.16906 11.4968 8.66654 11.9989 8.66654H21.0892C21.5912 8.66654 21.9982 8.16906 21.9982 7.55544C21.9982 6.94181 21.5913 6.44434 21.0892 6.44434Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90232 6.76978L2.26626 11.2142C1.91125 11.6481 1.91125 12.3516 2.26626 12.7855L5.90232 17.2299C6.07625 17.4425 6.30866 17.5554 6.54531 17.5554C6.6624 17.5554 6.78051 17.5277 6.89299 17.4708C7.23266 17.2988 7.45416 16.8937 7.45416 16.4443V7.55548C7.45416 7.10607 7.23266 6.70089 6.89299 6.52897C6.55325 6.35697 6.16225 6.452 5.90232 6.76978Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdentIcon);
export default __webpack_public_path__ + "static/media/outdentIcon.38250f6bfea0ff63f42828b8ea63ac0a.svg";
export { ForwardRef as ReactComponent };